<template>
  <select 
    v-model="selectedSite" 
    @change="handleSiteChange"
    class="bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm focus:ring-2 focus:ring-green-500 focus:border-green-500"
  >
    <option value="">เลือกไซต์</option>
    <option 
      v-for="site in availableSites" 
      :key="site.key" 
      :value="site.key"
      :selected="site.key === currentSite"
    >
      {{ site.icon }} {{ site.name }}
    </option>
  </select>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  currentSite: {
    type: String,
    default: 'main'
  }
})

const { navigateToSubdomain } = useClustersie()

const selectedSite = ref(props.currentSite)

const availableSites = [
  { key: 'main', name: 'แพลตฟอร์มหลัก', icon: '🏢' },
  { key: 'coffee', name: 'คลัสเตอร์กาแฟ', icon: '☕' },
  { key: 'fisheries', name: 'คลัสเตอร์ประมง', icon: '🐟' },
  { key: 'fruit', name: 'คลัสเตอร์ผลไม้', icon: '🍎' },
  { key: 'bittermelon', name: 'คลัสเตอร์มะระ', icon: '🥒' },
  { key: 'halal', name: 'คลัสเตอร์ฮาลาล', icon: '🥘' },
  { key: 'mulberry', name: 'คลัสเตอร์หม่อน', icon: '🫐' }
]

const handleSiteChange = () => {
  if (selectedSite.value && selectedSite.value !== props.currentSite) {
    navigateToSubdomain(selectedSite.value)
  }
}
</script>